import { Pipe, PipeTransform } from '@angular/core';
import { IData } from '../../menu-list-item/menu-list-item.component';
import { MenuService } from '../services/menu.service';

@Pipe({
	name: 'filter',
	standalone: false,
})
export class ReportFilterPipe implements PipeTransform {
	constructor(private menuService: MenuService) {}

	transform(items: any[], field: string, value: string): any[] {
		const filtered = items.filter((it) => {
			return it.report[field].toLowerCase().includes(value.toLowerCase());
		});
		if (!items) return [];
		if (!value || value.length === 0) return items;
		const data: IData = { report: this.menuService.reportSelect };

		if (!filtered.find((x) => data.report !== null && data.report.name.toLowerCase() === x.report.name.toLowerCase())) {
			filtered.push(data);
		}
		return filtered;
	}
}
